import { z } from 'zod/v4';

import { selectedFileSchemaLegacy } from '../../../common/schemas/legacy';

/**
 * Data shape for the `logo` widget — one picked file. The logo is a trimmed
 * image widget: it keeps the file (with its alt/link metadata, edited in the
 * `web-image-settings` sub-panel) and nothing else. Its size lives in the
 * envelope's typed `styles` bag (see `./styles`).
 *
 * Several further fields (alignment, shadow, border, animation, resize type,
 * `isSynchronizeStyle`) are commented out in the host's type and model and have
 * never been persisted — they are deliberately NOT modelled here.
 */
export const logoLegacyDataSchema = z.object({
    image: selectedFileSchemaLegacy.nullable(),
});
